import api from '../../../api/parametres/_fiche-consultations'

const state = () => ({
    
})

// getters
const getters = {
    
}

// mutations
const mutations = {
    
}

// actions
const actions = {
    saveSectionFicheConsultation({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveSectionFicheConsultation(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    gererChampsFicheConsultation({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.gererChampsFicheConsultation(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveFicheSectionOrder({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveFicheSectionOrder(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveFicheChampOrder({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveFicheChampOrder(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}